import { DocumentTypeProps } from "../../components/uiframeworks/files/uploads/panel";

const VesselDocumentTypes: DocumentTypeProps[] = [
    {key: "ship particular", text: "Ship particular"},
    {key: "photo", text: "Photo"},
    {key: "others", text: "Generic document", isDefault: true}
]

export default VesselDocumentTypes;